<ca-error-page type="sessionExpire" [caLocalizationScope]="localizationScope">
  <button class="btn btn-primary" (click)="onClick()">{{ 'login' | caLocalize }}</button>
</ca-error-page>
